import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ContactPersonSourceId {
  CRM = 'crm',
  DAKTELA = 'daktela',
  PMS = 'pms',
}

export class ContactPersonSource extends Codebook<ContactPersonSourceId> {
  static readonly CRM = new ContactPersonSource(ContactPersonSourceId.CRM, $t('CRM'))
  static readonly DAKTELA = new ContactPersonSource(ContactPersonSourceId.DAKTELA, $t('Daktela'))
  static readonly PMS = new ContactPersonSource(ContactPersonSourceId.PMS, $t('PMS'))

  private constructor(
    id: ContactPersonSourceId,
    public readonly name: string,
  ) {
    super(id)
  }
}
